import React, { useState, useEffect } from "react";
import styles from "./HomePage.module.css";

const HomePageCore = () => {
  const [activeTab, setActiveTab] = useState("upsc");
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [currentPosterSlide, setCurrentPosterSlide] = useState(0);
  const [currentTestimonialSlide, setCurrentTestimonialSlide] = useState(0);

  // REMOVED: unused razorpayLinks object

  // Syllabus data for each exam
  const syllabusData = {
    upsc: [
      { serial: 1, topic: "Linear Algebra", hours: 30 },
      { serial: 2, topic: "Calculus", hours: 40 },
      { serial: 3, topic: "Analytic Geometry", hours: 30 },
      { serial: 4, topic: "Differential Equations", hours: 40 },
      { serial: 5, topic: "Vector Analysis", hours: 20 },
      { serial: 6, topic: "Algebra", hours: 35 },
      { serial: 7, topic: "Real Analysis", hours: 40 },
      { serial: 8, topic: "Complex Analysis", hours: 20 },
      { serial: 9, topic: "Linear Programming", hours: 20 },
      { serial: 10, topic: "Numerical Analysis", hours: 25 },
      { serial: 11, topic: "Probability & Statistics", hours: 20 },
      { serial: 12, topic: "Mechanics", hours: 30 }
    ],
    bpsc: [
      { serial: 1, topic: "Linear Algebra", hours: 30 },
      { serial: 2, topic: "Calculus", hours: 35 },
      { serial: 3, topic: "Differential Equations", hours: 25 },
      { serial: 4, topic: "Analytic Geometry", hours: 25 },
      { serial: 5, topic: "Vector Analysis", hours: 20 },
      { serial: 6, topic: "Real Analysis", hours: 25 },
      { serial: 7, topic: "Complex Analysis", hours: 15 },
      { serial: 8, topic: "Numerical Analysis", hours: 25 },
      { serial: 9, topic: "Probability", hours: 20 },
      { serial: 10, topic: "Mechanics", hours: 30 }
    ],
    foundation: [
      { serial: 1, topic: "Basic Algebra", hours: 8 },
      { serial: 2, topic: "Trigonometry", hours: 8 },
      { serial: 3, topic: "Coordinate Geometry", hours: 7 },
      { serial: 4, topic: "Calculus Fundamentals", hours: 8 },
      { serial: 5, topic: "Vectors & 3D", hours: 7 },
      { serial: 6, topic: "Statistics", hours: 7 },
      { serial: 7, topic: "Probability Basics", hours: 5 },
      { serial: 8, topic: "Linear Programming", hours: 5 },
      { serial: 9, topic: "Mathematical Reasoning", hours: 5 },
      { serial: 10, topic: "Number System", hours: 3 },
      { serial: 11, topic: "Mensuration", hours: 2 },
      { serial: 12, topic: "Set Theory", hours: 5 }
    ],
    stet: [
      { serial: 1, topic: "Algebra", hours: 20 },
      { serial: 2, topic: "Trigonometry", hours: 15 },
      { serial: 3, topic: "Calculus", hours: 20 },
      { serial: 4, topic: "Coordinate Geometry", hours: 15 },
      { serial: 5, topic: "Vectors", hours: 12 },
      { serial: 6, topic: "Statistics", hours: 15 },
      { serial: 7, topic: "Probability", hours: 18 },
      { serial: 8, topic: "Mathematical Pedagogy", hours: 7 },
      { serial: 9, topic: "Number System", hours: 13 },
      { serial: 10, topic: "Set Theory", hours: 15 }
    ],
    csat: [
      { serial: 1, topic: "Number System", hours: 10 },
      { serial: 2, topic: "Arithmetic", hours: 10 },
      { serial: 3, topic: "Algebra", hours: 10 },
      { serial: 4, topic: "Geometry", hours: 15 },
      { serial: 5, topic: "Mensuration", hours: 10 },
      { serial: 6, topic: "Data Interpretation", hours: 20 },
      { serial: 7, topic: "Logical Reasoning", hours: 20 },
      { serial: 8, topic: "Reading Comprehension", hours: 25 }
    ],
    csir: [
      { serial: 1, topic: "Analysis", hours: 35 },
      { serial: 2, topic: "Linear Algebra", hours: 25 },
      { serial: 3, topic: "Abstract Algebra", hours: 15 },
      { serial: 4, topic: "Complex Analysis", hours: 25 },
      { serial: 5, topic: "Differential Equations", hours: 30 },
      { serial: 6, topic: "Topology", hours: 10 },
      { serial: 7, topic: "Numerical Analysis", hours: 20 },
      { serial: 8, topic: "Probability", hours: 20 },
      { serial: 9, topic: "Combinatorics", hours: 20 },
      { serial: 10, topic: "Mechanics", hours: 30 }
    ]
  };

  // Course data with expanded details
  const courses = {
    upsc: [
      {
        id: 1,
        title: "UPSC Mathematics Optional 2026",
        tag: "Most Popular",
        duration: "6 months",
        lectures: "350+ hours",
        tests: "22 tests",
        price: "₹24,999",
        razorpayLink: "https://rzp.io/rzp/exademy-education-upsc-2026",
        features: [
          "Paper I & II complete coverage",
          "500+ PYQs with video solutions",
          "12 sectional + 10 full mocks",
          "1:1 mentorship with Faculty Bi-Weekly",
          "E-Books (8 volumes)"
        ],
        icon: "fas fa-crown",
        color: "#0B5E42"
      }
    ],
    bpsc: [
      {
        id: 2,
        title: "BPSC Mathematics Optional 2026",
        tag: "State Focus",
        duration: "4 months",
        lectures: "250+ hours",
        tests: "10  New Pattern MCQ Test Series",
        price: "₹15,999",
        razorpayLink: "https://rzp.io/rzp/exademy-education-bpsc-math-20",
        features: [
          "Bihar PSC specific syllabus",
          "English answer writing",
          "BPSC past papers (2005-2025)",
          "State service focus",
          "Hindi/English both mediums",
          "Online Live Classes + Lecture Recording"
        ],
        icon: "fas fa-landmark",
        color: "#8B5CF6"
      }
    ],
    foundation: [
      {
        id: 3,
        title: "Mathematics Foundation Batch - For Mathematics Basics",
        tag: "Beginner Friendly",
        duration: "1.5 months",
        lectures: "70+ hours",
        tests: "5 Test Series",
        price: "₹4,999",
        razorpayLink: "https://rzp.io/rzp/exademy-education-upsc-2027",
        features: [
          "Concept building from basics",
          "1:1 Weekly Doubt Sessions",
          "5 Test Series",
          "Extra Focus on Step wise Answer Writing",
          "E-Books",
          "Doubt clearing sessions every alternate days"
        ],
        icon: "fas fa-calculator",
        color: "#2563EB"
      }
    ],
    stet: [
      {
        id: 5,
        title: "BPSC STET Mathematics 2026",
        tag: "Teaching Exam",
        duration: "3 months",
        lectures: "150+ hours",
        tests: "10 tests",
        price: "₹14,999",
        razorpayLink: "https://rzp.io/rzp/exademy-education-bpsc-stet",
        features: [
          "Paper I & II complete coverage",
          "Bihar specific syllabus",
          "Previous year papers (2015-2025)",
          "Teaching methodology",
          "Practice tests with solutions",
          "Doubt clearing sessions"
        ],
        icon: "fas fa-chalkboard-teacher",
        color: "#9C27B0"
      }
    ],
    csat: [
      {
        id: 6,
        title: "UPSC CSAT 2026",
        tag: "Aptitude",
        duration: "3 months",
        lectures: "120+ hours",
        tests: "10 tests",
        price: "₹9,999",
        razorpayLink: "https://rzp.io/rzp/exademy-education-upsc-csat",
        features: [
          "Comprehension & Reasoning",
          "Quantitative Aptitude",
          "Data Interpretation",
          "10 Full Length Tests",
          "Previous year solved papers",
          "Shortcut techniques"
        ],
        icon: "fas fa-brain",
        color: "#FF9800"
      }
    ],
    csir: [
      {
        id: 4,
        title: "CSIR NET Mathematics",
        tag: "Advanced",
        duration: "5 months",
        lectures: "230+ hours",
        tests: "10 tests",
        price: "₹19,999",
        razorpayLink: "https://rzp.io/rzp/exademy-education-csir-math",
        features: [
          "Full Syllabus Coverage",
          "10+ Test Series",
          "Digital Notes",
          "Daily Live Classes + Recordings",
          "JRF focused training",
          "Unit-wise problem sets"
        ],
        icon: "fas fa-square-root-alt",
        color: "#DC2626"
      }
    ]
  };

  // Course enrollment table data - 3 courses only
  const courseEnrollmentData = [
    {
      id: 1,
      name: "UPSC Mathematics Optional 2026",
      startDate: "15 Mar 2026",
      endDate: "15 Nov 2026",
      razorpayLink: "https://rzp.io/rzp/exademy-education-upsc-2026"
    },
    {
      id: 2,
      name: "UPSC Mathematics Optional 2027",
      startDate: "15 Jan 2027",
      endDate: "15 Sep 2027",
      razorpayLink: "https://rzp.io/rzp/exademy-education-upsc-2027"
    },
    {
      id: 3,
      name: "BPSC Mathematics Optional 2026",
      startDate: "20 Mar 2026",
      endDate: "20 Oct 2026",
      razorpayLink: "https://rzp.io/rzp/exademy-education-bpsc-math-20"
    }
  ];

  // Poster data - 6 posters
  const posters = [
    { id: 1, image: "/poster/poster1.jpg", alt: "Poster 1" },
    { id: 2, image: "/poster/poster2.jpg", alt: "Poster 2" },
    { id: 3, image: "/poster/poster3.jpg", alt: "Poster 3" },
    { id: 4, image: "/poster/poster4.jpg", alt: "Poster 4" },
    { id: 5, image: "/poster/poster5.jpg", alt: "Poster 5" },
    { id: 6, image: "/poster/poster6.jpg", alt: "Poster 6" }
  ];

  // Testimonial data - 10 testimonials
  const testimonials = [
    {
      id: 1,
      name: "Gauri Adhav",
      batch: "UPSC Mathematics Optional - 2024",
      text: "One year ago I had came across Exademy and decided to join upsc mathematics optional class and I will say this is the best decision I have ever made in my life. All the teachers really very good. Thank you so much for all the teachers for facilitating such a positive learning environment. Apart from mathematics optional Prabhash sir started memory classes for General studies, which is amazing platform for memorizing Such a vast syllabus by using momory techniques. Before this I was in fear how to remember such a vast information , Bocz it is very important From prelims point of view to remember the facts. Sir's enthusiasm for teaching is contagious, It's like a family.",
      rating: 5
    },
    {
      id: 2,
      name: "S Swathi",
      batch: "UPSC Mathematics Optional - 2024",
      text: "GOOD TEACHERS 😊 are the reason why ordinary students dream of doing extraordinary things,Exademy -Redefining Education is one such platform you find such teachers.I liked the most in this (UPSC Mathematical optional) course is focussing on Foundation plus Practice sessions along with Main course.Before this I joined in some other institute for the optional course ,they directly jumped into syllabus so I couldn't able to understand.At one point I thought of changing optional but from YouTube I got to know about Exademy (watched Prabhash sir classes) and I enrolled in this course. Today I am glad that I am a STUDENT OF EXADEMY.....",
      rating: 5
    },
    {
      id: 3,
      name: "Pratibha Tiwari",
      batch: "UPSC Mathematics Optional - 2024",
      text: "In terms of my experience, the complete course which I have already completed majorly, has helped me a lot in understanding the subjects.Every subject has been explained in a great detail that even a new candidate can easily and understand the problems.I am very thankful to the exademy for providing this one stop solution.Also Prabhash sir's and Asha Mam's along with other teachers in classes in GS is amazing as the tricks and techniques by them is amazing. Now things taught are on my finger tips. It has helped me a lot. Thank you so much to all the teachers of Exademy for the great help",
      rating: 5
    },
    {
      id: 4,
      name: "Shakti Shyam Sethy",
      batch: "UPSC Mathematics Optional - 2024",
      text: "Amazing class atmosphere with amiable faculties 😊. The faculty members consistently demonstrate exceptional dedication to student learning, creating a stimulating and supportive environment through their insightful instruction and unwavering commitment to academic excellence.",
      rating: 5
    },
    {
      id: 5,
      name: "Yashwardhan Singh",
      batch: "Youtube Channel - Student",
      text: "Sir I was confused which classes i should join for maths optional. Then i found your channel and start taking lectures. One day i switched on another channel but didn't find it worthy for me. Now I'm continuing with you. Your way of explanation is awesome. I can connect myself with lectures without any pressure and burden. Thank you so much for this quality and interesting lectures.",
      rating: 5
    },
    {
      id: 6,
      name: "Nitish Garg",
      batch: "UPSC Mathematics Optional - 2023",
      text: "It is one of the best institute for UPSC maths. They conduct classes online which you can attend from the comfort of your home. Much better than *** and other big institutions in terms of fees , study quality, teaching method, Doubt solving.",
      rating: 5
    },
    {
      id: 7,
      name: "Akshay Hooda",
      batch: "UPSC Mathematics Optional - 2023",
      text: "Exademy is an exceptional platform for upsc aspirants especially for those having mathematics as optional.The extraordinary efforts of Prabhash Sir ,his guidance & mentorship proved helpful for me.Thanks a lot Sir and Team Exademy 🙏",
      rating: 5
    },
    {
      id: 8,
      name: "Rahi Agrawal",
      batch: "Exademy Application Student",
      text: "Exademy is an exceptional education app that has exceeded my expectations in every way. It offers a vast range of high-quality content, interactive learning tools, a personalized learning path, and a seamless user experience. The app's continuous support and updates make it the perfect companion for anyone seeking an unparalleled learning experience. I highly recommend Exademy with a resounding five-star rating.",
      rating: 5
    },
    {
      id: 9,
      name: "Pramod Parte",
      batch: "UPSC Mathematics Optional - 2022",
      text: "All teachers are supportive and very helpful and friendly and available, my experience is till now EXADMY is best online platform, Exadmy is like a family, thank you so much EXADEMY😊😊",
      rating: 5
    },
    {
      id: 10,
      name: "Raj Verma",
      batch: "UPSC Mathematics Optional - 2022",
      text: "Best coaching institute, best teachers.Any student who wants to study math optional should do so here.Most trustworthy institute, EXADEMY",
      rating: 5
    }
  ];

  // Auto-slide for posters
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentPosterSlide((prev) => 
        prev >= posters.length - 4 ? 0 : prev + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, [posters.length]);

  // Auto-slide for testimonials
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonialSlide((prev) => 
        prev >= testimonials.length - 4 ? 0 : prev + 1
      );
    }, 4000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  // UPDATED: Download handler - now opens Google Drive link
  const handleDownload = () => {
    window.open("https://drive.google.com/file/d/1us39SJfUmVWphizZdv2fVUfu7fcTK_JL/view?usp=sharing", "_blank");
  };
  // Video modal handler
  const openVideoModal = () => {
    setIsVideoModalOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeVideoModal = () => {
    setIsVideoModalOpen(false);
    document.body.style.overflow = "auto";
  };

  // Next/Prev slide handlers for posters
  const nextSlide = () => {
    setCurrentPosterSlide((prev) => 
      prev >= posters.length - 4 ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrentPosterSlide((prev) => 
      prev === 0 ? posters.length - 4 : prev - 1
    );
  };

  // Handler for Razorpay redirection
  const handleRazorpayRedirect = (razorpayLink) => {
    window.open(razorpayLink, "_blank");
  };

  // Extract YouTube video ID from URL
  const youtubeVideoId = "Efu4UofqxIw";

  // Render star rating
  const renderStars = (rating) => {
    return Array(5).fill(0).map((_, i) => (
      <i key={i} className={`fas fa-star ${i < rating ? styles.starFilled : styles.starEmpty}`}></i>
    ));
  };

  // Effect to handle hash navigation and set active tab
  useEffect(() => {
    // Check if there's a hash in the URL when component mounts
    if (window.location.hash) {
      const hash = window.location.hash.substring(1); // Remove the # symbol
      
      // Set active tab based on hash
      if (hash === 'upsc-section') {
        setActiveTab('upsc');
      } else if (hash === 'bpsc-section') {
        setActiveTab('bpsc');
      } else if (hash === 'foundation-section') {
        setActiveTab('foundation');
      } else if (hash === 'stet-section') {
        setActiveTab('stet');
      } else if (hash === 'csat-section') {
        setActiveTab('csat');
      } else if (hash === 'csir-section') {
        setActiveTab('csir');
      }
    }
  }, []);

  return (
    <main className={styles.mathHomeCore}>
      <div className={styles.container}>
        {/* ===== HERO SECTION ===== */}
        <section className={styles.hero}>
          <div className={styles.heroGrid}>
            <div className={styles.heroContent}>
              <div className={styles.heroBadge}>
                <span className={styles.badgeLive}>LIVE NOW</span>
                <span className={styles.badgeNew}>2026 BATCH STARTING</span>
              </div>
              <h1 className={styles.heroTitle}>
                <span className={styles.titleEmphasis}>Mathematics Optional</span>
                <br />UPSC • BPSC • State PSC
              </h1>
              <p className={styles.heroSubtitle}>
                India's most comprehensive mathematics program. <br />
                <strong>IITIAN</strong> Faculty with 8+ years of Experience.
              </p>
              
              <div className={styles.heroCta}>
                <button 
                  className={styles.ctaPrimary}
                  onClick={handleDownload}
                >
                  <i className="fas fa-file-pdf"></i>
                  Download Brochure 2026
                  <span className={styles.ctaBadge}>Free</span>
                </button>
                <button 
                  className={styles.ctaSecondary}
                  onClick={openVideoModal}
                >
                  <i className="fas fa-play-circle"></i>
                  Watch Demo
                </button>
              </div>
            </div>

            <div className={styles.heroVisual}>
              {/* Course Enrollment Table - 3 courses only */}
              <div className={styles.courseTableContainer}>
                <h3 className={styles.courseTableTitle}>Upcoming Batches</h3>
                <div className={styles.courseTableWrapper}>
                  <table className={styles.courseTable}>
                    <thead>
                      <tr>
                        <th>Course Name</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Enroll</th>
                      </tr>
                    </thead>
                    <tbody>
                      {courseEnrollmentData.map((course) => (
                        <tr key={course.id}>
                          <td className={styles.courseNameCell}>{course.name}</td>
                          <td className={styles.dateCell}>{course.startDate}</td>
                          <td className={styles.dateCell}>{course.endDate}</td>
                          <td className={styles.enrollCell}>
                            <button 
                              className={styles.enrollButton}
                              onClick={() => handleRazorpayRedirect(course.razorpayLink)}
                            >
                              Enroll Now
                              <i className="fas fa-arrow-right"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ===== POSTER CAROUSEL SECTION ===== */}
        <section className={styles.posterCarouselSection}>
          <div className={styles.posterCarouselContainer}>
            <button 
              className={styles.carouselArrowLeft} 
              onClick={prevSlide}
              aria-label="Previous posters"
            >
              <i className="fas fa-chevron-left"></i>
            </button>
            
            <div className={styles.posterCarouselTrack}>
              <div 
                className={styles.posterCarouselSlides}
                style={{
                  transform: `translateX(-${currentPosterSlide * 25}%)`
                }}
              >
                {posters.map((poster) => (
                  <div key={poster.id} className={styles.posterCarouselItem}>
                    <div className={styles.posterCarouselCard}>
                      <img 
                        src={poster.image} 
                        alt={poster.alt} 
                        className={styles.posterCarouselImage}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            <button 
              className={styles.carouselArrowRight} 
              onClick={nextSlide}
              aria-label="Next posters"
            >
              <i className="fas fa-chevron-right"></i>
            </button>
          </div>
          
          {/* Dots indicator */}
          <div className={styles.carouselDots}>
            {Array.from({ length: Math.ceil(posters.length / 4) }).map((_, index) => (
              <button
                key={index}
                className={`${styles.carouselDot} ${
                  Math.floor(currentPosterSlide / 1) === index ? styles.carouselDotActive : ''
                }`}
                onClick={() => setCurrentPosterSlide(index * 4)}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </section>

        {/* ===== COURSE MATRIX ===== */}
        <section className={styles.courseMatrix}>
          <div className={styles.sectionHeader}>
            <h2>Courses designed for <span className={styles.gradientText}>every milestone</span></h2>
            <p className={styles.sectionDesc}>Compare features, duration, and pricing. No hidden costs.</p>
          </div>

          <div className={styles.courseTabs}>
            <button 
              id="upsc-section"
              className={`${styles.tabBtn} ${activeTab === 'upsc' ? styles.tabActive : ''}`}
              onClick={() => setActiveTab('upsc')}
            >
              UPSC
            </button>
            <button 
              id="bpsc-section"
              className={`${styles.tabBtn} ${activeTab === 'bpsc' ? styles.tabActive : ''}`}
              onClick={() => setActiveTab('bpsc')}
            >
              BPSC
            </button>
            <button 
              id="foundation-section"
              className={`${styles.tabBtn} ${activeTab === 'foundation' ? styles.tabActive : ''}`}
              onClick={() => setActiveTab('foundation')}
            >
              Foundation
            </button>
            <button 
              id="stet-section"
              className={`${styles.tabBtn} ${activeTab === 'stet' ? styles.tabActive : ''}`}
              onClick={() => setActiveTab('stet')}
            >
              STET
            </button>
            <button 
              id="csat-section"
              className={`${styles.tabBtn} ${activeTab === 'csat' ? styles.tabActive : ''}`}
              onClick={() => setActiveTab('csat')}
            >
              CSAT
            </button>
            <button 
              id="csir-section"
              className={`${styles.tabBtn} ${activeTab === 'csir' ? styles.tabActive : ''}`}
              onClick={() => setActiveTab('csir')}
            >
              CSIR NET
            </button>
          </div>

          <div className={styles.courseShowcase}>
            {courses[activeTab]?.map((course) => (
              <div key={course.id} className={styles.courseRow}>
                <div className={styles.courseCard}>
                  <div className={styles.courseCardHeader} style={{ background: `linear-gradient(145deg, ${course.color}15, ${course.color}05)` }}>
                    <span className={styles.courseTag} style={{ background: course.color }}>{course.tag}</span>
                    <i className={course.icon} style={{ color: course.color }}></i>
                  </div>
                  <div className={styles.courseCardBody}>
                    <h3>{course.title}</h3>
                    <div className={styles.courseMeta}>
                      <span><i className="fas fa-clock"></i> {course.duration}</span>
                      <span><i className="fas fa-video"></i> {course.lectures}</span>
                      <span><i className="fas fa-file-alt"></i> {course.tests}</span>
                    </div>
                    <ul className={styles.courseFeatures}>
                      {course.features.map((feature, idx) => (
                        <li key={idx}><i className="fas fa-check-circle"></i> {feature}</li>
                      ))}
                    </ul>
                  </div>
                  <div className={styles.courseCardFooter}>
                    <div className={styles.coursePrice}>
                      <span className={styles.priceLabel}>from</span>
                      <span className={styles.priceValue}>{course.price}</span>
                    </div>
                    <button 
                      className={styles.courseEnrollBtn}
                      onClick={() => handleRazorpayRedirect(course.razorpayLink)}
                    >
                      Enroll Now <i className="fas fa-arrow-right"></i>
                    </button>
                  </div>
                </div>

                {/* Syllabus Table */}
                <div className={styles.syllabusTable}>
                  <h4 className={styles.syllabusTitle}>Topic-wise Breakup</h4>
                  <table>
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Topic Name</th>
                        <th>Hours</th>
                      </tr>
                    </thead>
                    <tbody>
                      {syllabusData[activeTab]?.map((item) => (
                        <tr key={item.serial}>
                          <td>{item.serial}</td>
                          <td>{item.topic}</td>
                          <td>{item.hours} hrs</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* ===== WHY US ===== */}
        <section className={styles.whyUs}>
          <div className={styles.sectionHeaderCenter}>
            <h2>Why 1,000+ aspirants <span className={styles.gradientText}>choose us</span></h2>
          </div>

          <div className={styles.advantageGrid}>
            <div className={styles.advantageCard}>
              <div className={styles.advantageIcon}>
                <i className="fas fa-chart-line"></i>
              </div>
              <h3>Proven Track Record</h3>
              <p>Every year most of the questions resembles from our Live classes and test series.</p>
              <span className={styles.advantageStat}>318 marks</span>
            </div>
            <div className={styles.advantageCard}>
              <div className={styles.advantageIcon}>
                <i className="fas fa-users"></i>
              </div>
              <h3>Elite Faculty</h3>
              <p>Faculties from IIT's. Average experience: 8+ years.</p>
              <span className={styles.advantageStat}>8+ yrs</span>
            </div>
            <div className={styles.advantageCard}>
              <div className={styles.advantageIcon}>
                <i className="fas fa-pen-fancy"></i>
              </div>
              <h3>Answer Writing Edge</h3>
              <p>20 evaluation sessions per student. Personalized feedback. 25+ mock tests with all-India ranking.</p>
              <span className={styles.advantageStat}>20 sessions</span>
            </div>
            <div className={styles.advantageCard}>
              <div className={styles.advantageIcon}>
                <i className="fas fa-layer-group"></i>
              </div>
              <h3>Integrated PYQs</h3>
              <p>300+ past year questions integrated chapter-wise. Trend analysis for UPSC/BPSC 2000-2025.</p>
              <span className={styles.advantageStat}>300+ PYQs</span>
            </div>
            <div className={styles.advantageCard}>
              <div className={styles.advantageIcon}>
                <i className="fas fa-print"></i>
              </div>
              <h3>Premium E-Books</h3>
              <p>8 volumes of E-books. Concise, updated, error-free.With Step wise answer writing.</p>
              <span className={styles.advantageStat}>8 volumes</span>
            </div>
            <div className={styles.advantageCard}>
              <div className={styles.advantageIcon}>
                <i className="fas fa-infinity"></i>
              </div>
              <h3>Course Validity</h3>
              <p>Course access will be extended for 1 year based on Test series results. Recorded lectures, live sessions, and updates included.</p>
              <span className={styles.advantageStat}>No expiry</span>
            </div>
          </div>
        </section>

        {/* ===== BROCHURE PREMIUM ===== */}
        <section className={styles.brochurePremium}>
          <div className={styles.brochureGlass}>
            <div className={styles.brochureGrid}>
              <div className={styles.brochureInfo}>
                <span className={styles.brochureBadge}>2026 EDITION • JUST RELEASED</span>
                <h2>Complete course guide & syllabus breakdown</h2>
                <p>48 pages | Topic-wise weightage | Faculty profiles | Past results | Scholarship criteria</p>
                
                <div className={styles.brochureHighlights}>
                  <span><i className="fas fa-check"></i> UPSC/BPSC comparison</span>
                  <span><i className="fas fa-check"></i> Sample lectures</span>
                  <span><i className="fas fa-check"></i> Fee structure</span>
                  <span><i className="fas fa-check"></i> EMI options</span>
                </div>

                <div className={styles.brochureActions}>
                  <button 
                    className={styles.brochureBtnPrimary}
                    onClick={handleDownload}
                  >
                    <i className="fas fa-file-pdf"></i>
                    Download Brochure (PDF)
                    <span className={styles.brochureBtnBadge}>Free</span>
                  </button>
                  <button 
                    className={styles.brochureBtnSecondary}
                    onClick={() => handleDownload("syllabus")}
                  >
                    <i className="fas fa-download"></i>
                    Syllabus only
                  </button>
                </div>
              </div>

              <div className={styles.brochureMockup}>
                <div className={styles.mockupCircle}></div>
                <div className={styles.mockupCard}>
                  <i className="fas fa-calculator"></i>
                  <div className={styles.mockupLines}>
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ===== COMPARISON CHART ===== */}
        <section className={styles.comparisonSection}>
          <div className={styles.sectionHeaderCenter}>
            <h2>Exademy vs <span className={styles.gradientText}>others</span></h2>
          </div>

          <div className={styles.comparisonTable}>
            <div className={styles.comparisonRow}>
              <div className={styles.comparisonFeature}>Topic-wise PYQ integration</div>
              <div className={styles.comparisonUs}><i className="fas fa-check"></i> Yes, since 2000</div>
              <div className={styles.comparisonOther}><i className="fas fa-times"></i> Only last 5 years</div>
            </div>
            <div className={styles.comparisonRow}>
              <div className={styles.comparisonFeature}>Printed study material</div>
              <div className={styles.comparisonUs}><i className="fas fa-check"></i> 8 E-Books, Free</div>
              <div className={styles.comparisonOther}><i className="fas fa-times"></i> extra cost</div>
            </div>
            <div className={styles.comparisonRow}>
              <div className={styles.comparisonFeature}>Mentorship by rank holders</div>
              <div className={styles.comparisonUs}><i className="fas fa-check"></i> 1:1 sessions, unlimited</div>
              <div className={styles.comparisonOther}><i className="fas fa-times"></i> Group doubt clearing</div>
            </div>
            <div className={styles.comparisonRow}>
              <div className={styles.comparisonFeature}>Test series evaluation</div>
              <div className={styles.comparisonUs}><i className="fas fa-check"></i> Detailed, 20 sessions</div>
              <div className={styles.comparisonOther}><i className="fas fa-times"></i> Automated / brief</div>
            </div>
            <div className={styles.comparisonRow}>
              <div className={styles.comparisonFeature}>Course validity</div>
              <div className={styles.comparisonUs}><i className="fas fa-check"></i> Until exam</div>
              <div className={styles.comparisonOther}><i className="fas fa-times"></i> 12 months</div>
            </div>
          </div>
        </section>

        {/* ===== FAQ SECTION - 3 COLUMNS PER ROW ===== */}
        <section className={styles.faqSection}>
          <div className={styles.sectionHeaderCenter}>
            <h2>Frequently asked <span className={styles.gradientText}>questions</span></h2>
          </div>

          <div className={styles.faqGrid}>
            {/* Row 1 - 3 FAQs */}
            <div className={styles.faqItem}>
              <h4>Is mathematics optional scoring?</h4>
              <p>Yes. Average marks in UPSC maths optional: 280-350. With structured preparation, 320+ is achievable.</p>
            </div>
            <div className={styles.faqItem}>
              <h4>Can I switch from BPSC to UPSC?</h4>
              <p>Absolutely by paying Rs. 5000 + GST. 80% syllabus overlaps. Our BPSC students get free access to UPSC-specific modules and vice versa.</p>
            </div>
            <div className={styles.faqItem}>
              <h4>What is the validity of courses?</h4>
              <p>All courses are valid until your exam date. No strict expiry. You get free updates for 1 year based on Previous Test Scores.</p>
            </div>
            
            {/* Row 2 - 3 FAQs */}
            <div className={styles.faqItem}>
              <h4>Do you provide Hindi medium support?</h4>
              <p>Yes, for BPSC and UPSC. Bilingual classes, Hindi answer evaluation, and Hindi doubt clearing sessions available.</p>
            </div>
            <div className={styles.faqItem}>
              <h4>Is there any scholarship?</h4>
              <p>Merit-cum-means scholarship available. Up to 100% fee waiver for Prelims Qualified Candidates or students who have ever reached interview stage.</p>
            </div>
            <div className={styles.faqItem}>
              <h4>How are tests evaluated?</h4>
              <p>One-on-one video feedback. Detailed comments on presentation, speed, accuracy, and conceptual clarity.</p>
            </div>
          </div>
        </section>

        {/* ===== TESTIMONIAL SLIDER SECTION ===== */}
        <section className={styles.testimonialSection}>
          <div className={styles.sectionHeaderCenter}>
            <h2>What our <span className={styles.gradientText}>Students</span> say</h2>
            <p className={styles.sectionDesc}>10,000+ aspirants have prepared for their exams with Exademy</p>
          </div>

          <div className={styles.testimonialCarousel}>
            <div className={styles.testimonialTrack}>
              <div 
                className={styles.testimonialSlides}
                style={{
                  transform: `translateX(-${currentTestimonialSlide * 25}%)`
                }}
              >
                {testimonials.map((testimonial) => (
                  <div key={testimonial.id} className={styles.testimonialItem}>
                    <div className={styles.testimonialCard}>
                      <div className={styles.testimonialHeader}>
                        <div className={styles.testimonialInfo}>
                          <h4>{testimonial.name}</h4>
                          <p className={styles.testimonialBatch}>{testimonial.batch}</p>
                          <div className={styles.testimonialRating}>
                            {renderStars(testimonial.rating)}
                          </div>
                        </div>
                      </div>
                      <div className={styles.testimonialText}>
                        <i className="fas fa-quote-left"></i>
                        <p>{testimonial.text}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            {/* Dots indicator */}
            <div className={styles.testimonialDots}>
              {Array.from({ length: Math.ceil(testimonials.length / 4) }).map((_, index) => (
                <button
                  key={index}
                  className={`${styles.testimonialDot} ${
                    Math.floor(currentTestimonialSlide / 1) === index ? styles.testimonialDotActive : ''
                  }`}
                  onClick={() => setCurrentTestimonialSlide(index * 4)}
                  aria-label={`Go to testimonial group ${index + 1}`}
                />
              ))}
            </div>
          </div>

          {/* REMOVED: Google Review Link section */}
        </section>
      </div>

      {/* ===== VIDEO MODAL ===== */}
      {isVideoModalOpen && (
        <div className={styles.videoModalOverlay} onClick={closeVideoModal}>
          <div className={styles.videoModalContent} onClick={(e) => e.stopPropagation()}>
            <button className={styles.closeModalBtn} onClick={closeVideoModal}>
              <i className="fas fa-times"></i>
            </button>
            <div className={styles.videoWrapper}>
              <iframe
                width="100%"
                height="100%"
                src={`https://www.youtube.com/embed/${youtubeVideoId}?autoplay=1&rel=0&modestbranding=1`}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </main>
  );
};

export default HomePageCore;